import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_INPATIENT_METRICS_REQUEST: '', // GET
  GET_INPATIENT_METRICS_SUCCESS: '',
  GET_INPATIENT_METRICS_FAILURE: '',
};

types = setStoreTypeValues(types, 'metrics');

export default types;
